import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import { useSelector } from 'react-redux';
import HttpAPICall from '../../services/HttpAPICall';
import { IAM_API_BASE_URL_2 } from '../../services/TapApiUrls';
import Ax from "../../components/hoc/Ax";
import Loader from "../../components/ui/Loader/Loader";
import { toast } from 'react-toastify';
import TapHelper from '../../services/TapHelper';
import DateService from '../../services/DateService';
import TapIcon from '../../services/TapIcon';

const PaymentDataDetail = forwardRef((props, ref) => {
  const access_token = useSelector(state => state.auth.access_token);
  const [paymentData, setPaymentData] = useState(null);
  const [viewDataLoading, setViewDataLoading] = useState(false);

  const getPaymentDetail = (id) => {
    setViewDataLoading(true);
    HttpAPICall.withAthorization('GET', IAM_API_BASE_URL_2 + '/payment/detail/' + id, access_token, {}, {},
      (response) => {
        setPaymentData(response.data);
        setViewDataLoading(false);
      },
      (error) => {
        toast.error(error?.msg, {
          position: toast.POSITION.TOP_RIGHT
        });
        setViewDataLoading(false);
      }
    );
  };

  useEffect(() => {
    if (props.paymentId) {
      getPaymentDetail(props.paymentId);
    }
  }, [props.paymentId]);

  const renderPaymentDetail = () => {
    if (!paymentData) return null;
    const detail = paymentData;

    return (
      <Ax>
        <div className="tab_content_wrapper my-2">
          <span className="content_heading">Payment Information</span>
        </div>
        <table className="table table-hover table-bordered">
          <tbody>
            <tr>
              <td style={{ width: "25%" }}>Transaction ID</td>
              <th style={{ width: "65%" }}>{detail?.transaction_id || '-'}</th>
            </tr>
            <tr>
              <td>Transaction Date</td>
              <th>{detail?.transaction_date ? DateService.dateFormat(detail.transaction_date) : '-'}</th>
            </tr>
             <tr>
              <td>Expense Id</td>
              <th className="text-capitalize">{detail?.expense_id || '-'}</th>
            </tr>
            <tr>
              <td>Payment From</td>
              <th className="text-capitalize">{detail?.payment_from || '-'}</th>
            </tr>
            <tr>
              <td>Wallet</td>
              <th className="text-capitalize">{detail?.wallet?.wallet_name || '-'}</th>
            </tr>
            <tr>
              <td>Payment Date</td>
              <th>{detail?.payment_date ? DateService.dateFormat(detail.payment_date) : '-'}</th>
            </tr>
            <tr>
              <td>Payment Mode</td>
              <th>{detail?.payment_mode || '-'}</th>
            </tr>
            <tr>
              <td>Reference Number</td>
              <th>{detail?.reference_number || '-'}</th>
            </tr>
            <tr>
              <td>Notes</td>
              <th>{detail?.notes || '-'}</th>
            </tr>

          </tbody>
        </table>
        {detail?.logs && detail?.logs.length > 0 && <>
          <div className="tab_content_wrapper mt-3">
            <span className="content_heading">Remarks</span>
          </div>
          <div className="row my-2">
            {detail?.logs?.map((c, k) => {
              return (
                <Ax key={k}>
                  <div className="row">
                    <div className="col-sm-12">
                      <span className="fw-bold link-primary"> {c.created_by} </span>
                      Added a remark on <span className="fw-bold"> {c.created_at ? DateService.dateTimeFormat(c.created_at) : ""}</span>
                    </div>
                    <div className="col-sm-12 my-1"> <span> {c.remark}</span> </div>
                  </div>
                  <hr />
                </Ax>
              );
            })}
          </div>
        </>
        }
      </Ax>
    );
  };

  if (viewDataLoading) {
    return (
      <div className="text-center p-5">
        <Loader />
      </div>
    );
  }

  if (!paymentData) {
    return (
      <div className="text-center p-3 text-muted">
        <p>No payment data available</p>
      </div>
    );
  }

  return (
    <Ax>
      {renderPaymentDetail()}
    </Ax>
  );
});

export default PaymentDataDetail;